<template>
        <div v-if="match">
            <div class="row columns text-centered">
               <span>
                <img class="small-league-icon" :src="getLeagueIcon(match.home_report.team)" alt="team">
                    DungeonBowl du {{match.date | formatDate}} :
                </span>
            </div>
            <div>
                <div class="row columns match_line">
                    <div class="large-6 columns" v-for="tr in match.team_reports">
                        <div class="row">
                            <div class="large-2 columns">
                                <img class="team-icon-big" v-bind:src="getRosterIcon(tr.team)">
                            </div>
                            <div class="large-7 columns text-left">
                                <div class="match-team-name"><router-link :to="{ name: 'TeamDetail', params: { id: tr.team.id.toString() }}">{{tr.team.name}}</router-link></div>
                                <div class="row columns match-stats"><i class="fa fa-tag" aria-hidden="true"></i> {{tr.team.ref_roster}}</div>
                                <div class="row columns match-stats"><i class="fa fa-user" aria-hidden="true"></i> Coachés par {{tr.team.user}}</div>
                            </div>
                            <div class="large-2 columns">
                                <div class="match-team-name">{{getTDCount(tr)}}</div>
                            </div>
                            <div class="large-1 columns">
                            </div>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
            <div v-if="actions" class="row columns">
                <router-link v-if="canBeContinued" :to="{ name: 'mrDBStep2', params: { id: match.id.toString() }}" >
                    <button>Continuer la saisie du rapport</button>
                </router-link>
                <button v-if="canBeContinued" @click="remove" class="alert">Supprimer</button>
                <router-link v-else :to="{ name: 'DBDetail', params: { id: match.id.toString() }}" >
                    <button class="light-grey-button">Details</button>
                </router-link>
            </div>
        </div>
        <div v-else>
            <spinner></spinner>
        </div>
</template>

<script>
import spinner from '../common/spinner.vue'
import formatDate from '../../common/filters.js'
import { mapGetters } from 'vuex'

export default {
  name: 'mrDBHeader',
  components: {
    spinner
  },
  props: {
    'match': null,
    'actions': true
  },
  data () {
    return {
    }
  },
  computed: {
    canBeContinued: function () {
      // dit si oui ou non le rapport de match peut être édité
      // il faut qu'il ne soit pas publié
      if (this.match.status === 1) {
        return false
      }

      if (this.currentUser.is_superuser === true) {
        return true
      }

      // il faut que l'utilisateur connecté soit le coach d'une des deux équipe, ou un superuser
      if ((this.match.home_report.team.user === this.currentUser.username) || (this.match.visitor_report.team.user === this.currentUser.username)) {
        return true
      }
      return false
    },
    ...mapGetters([
      'currentUser',
      'clubList'
    ])
  },
  filters: {
    formatDate
  },
  methods: {
    getTDCount: function (tr) {
      let tdCount = 0
      tr.player_report.forEach(pr => {
        tdCount += pr.nb_td
      })
      return tdCount
    },
    remove () {
    },
    getLeagueIcon () {
      let club = this.clubList.find(c => { return c.leagues.find(l => { return l.id === this.match.league.id }) })
      return club.icon_path
    },
    getRosterIcon (team) {
      if (team.ref_roster !== undefined) {
        return '/static/imgs/team-icons/' + team.ref_roster.replace(/\s+/, '') + '.png'
      }
      return ''
    },
    weather (report) {
      if (report.weather === '0') {
        return 'Canicule'
      } else if (report.weather === '1') {
        return 'Trés ensoleillé'
      } else if (report.weather === '2') {
        return 'Clément'
      } else if (report.weather === '3') {
        return 'Averse'
      } else if (report.weather === '4') {
        return 'Blizzard'
      }
      return ''
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.small-league-icon {
    width: 60px;
    height: 75px;
}

.big-title {
    font-size: 1.6rem;
}
.team-score {
    font-size: 2rem;
    font-weight: 450;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-result {
    font-size: 1.2rem;
    font-weight: 200;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-team-name {
    font-size: 1.4rem;
    font-weight: 400;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-stats {
    font-size: 0.9rem;
    font-weight: 300;
}

.single-stat {
    margin: 0.5rem;
}

.match_line {
    padding-top: 0rem;
}

.team-icon-big {
    margin-top: 1.5rem;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tr td{
    padding: 0.5rem 0.2rem;
    text-align: center;
    font-size:0.7rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}
</style>



// WEBPACK FOOTER //
// mr-db-header.vue?743881a6